export function ServiceGuide({ guide }) {
  if (!guide) return null;
  return (
    <section className="mt-12 space-y-9" data-testid="service-guide">
      <div>
        <h2 className="font-heading text-2xl font-extrabold text-[#0a192f]">Who this service is for</h2>
        <p className="mt-4 leading-relaxed text-slate-600">{guide.audience}</p>
      </div>
      <div>
        <h2 className="font-heading text-2xl font-extrabold text-[#0a192f]">Information & documents to prepare</h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">Use this starting checklist for your consultation. We confirm the exact documents and applicable requirements after reviewing your activity and location.</p>
        <ul className="mt-4 grid gap-3 sm:grid-cols-2">
          {guide.prepare.map((item) => <li key={item} className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm leading-relaxed text-slate-700">{item}</li>)}
        </ul>
      </div>
      <div>
        <h2 className="font-heading text-2xl font-extrabold text-[#0a192f]">How we help with this service</h2>
        <ol className="mt-4 space-y-3">
          {guide.process.map((step, index) => <li key={step} className="flex gap-3 text-sm leading-relaxed text-slate-600"><span className="font-bold text-[#b07f0a]">{index + 1}.</span><span>{step}</span></li>)}
        </ol>
      </div>
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-6">
        <h2 className="font-heading text-xl font-extrabold text-[#0a192f]">Fees & timing</h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-700">{guide.fees}</p>
        <p className="mt-3 text-sm leading-relaxed text-slate-700">{guide.timing}</p>
      </div>
    </section>
  );
}
